
const BASE_URL = "/leaf/proxy/reg-svc/api/v1/registration/";

export const FetchGet = (path: string, processJson: (json: any) => void) => {
    return fetch(BASE_URL + path, {
        credentials: 'include',
        headers: getHeaders(),
    })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText + ' ' + response.status);
            }
            return response.json();
        })
        .then((json) => {
            processJson(json);
        })
        .catch((err) => {
            console.error('Error:', err);
        });
};

export const FetchPost = (csrfToken: string, path: string, body: any, processJson: (json: any) => void,
    errorCallback: (err: any) => void) => {
    return fetch(BASE_URL + path, {
        method: 'POST',
        credentials: 'include',
        headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken
        },
        body: JSON.stringify(body)
    })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText + ' ' + response.status);
            }
            return response.json();
        })
        .then((json) => {
            processJson(json);
        })
        .catch((err) => {
            console.error('Error:', err);
            errorCallback(err);
        });
}

const getHeaders = (): HeadersInit | undefined => {
    if (process.env.REACT_APP_FORWARDED_HOST === undefined) {
        return {};
    }
    return {
        'X-Forwarded-Host': process.env.REACT_APP_FORWARDED_HOST,
        'X-Forwarded-Proto': 'https',
    };
}